<template>
  <div>
    <el-page-header @back="goBack" content=" 维护测评题目"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay">
              共 <i>{{ detalisObj.questions }} </i>题，<i
            >{{ detalisObj.maxScore }} </i
            >分
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer box_intab">
      <div class="chang_tab">
        <div @click="changActiveItem(1)" class="item_box" :class="{'active_item':active_item==1}">维度管理</div>
        <div @click="changActiveItem(2)" class="item_box" :class="{'active_item':active_item==2}">能力倾向</div>
        <div @click="changActiveItem(3)" class="item_box" :class="{'active_item':active_item==3}">脸谱管理</div>
      </div>
      <div v-if="active_item==1">
        <div class="tag_tome_bole">
          <div class="left">
            <div @click='editSave(1,"add")' class="name_box_head">维度 <i class="el-icon-circle-plus-outline"
                                                                        style="margin-right: 10px"></i></div>
            <div class="content_left">
              <el-tree :highlight-current="true" :default-expand-all="true"
                       :expand-on-click-node="false" style="text-align: center" :data="data" :props="defaultProps"
                       @node-click="handleNodeClick">
                 <span class="custom-tree-node" style="width:100%;display: flex;justify-content: space-between"
                       slot-scope="{ node, data }">
        <span style="display: block;max-width:80px;overflow: hidden;text-overflow: ellipsis ">{{ node.label }}</span>
        <span>
          <i v-if="node.level==1" class="el-icon-circle-plus-outline" @click='editSave(1,"add",data)'
             style="margin-right: 10px"></i>
          <i class="el-icon-edit" @click='editSave(1,"edit",data)' style="margin-right: 10px"></i>
          <i @click="DelectDomin(1,data)" class="el-icon-delete" style="margin-right: 10px"></i>
        </span>
      </span>
              </el-tree>
            </div>
          </div>
          <div class="right">
            <div class="right_tops" style="margin-bottom: 10px">
              <div class="items" v-if="dimensionName">维度：{{ dimensionName }}</div>
            </div>
            <div>
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="题目设置" name="first" v-if="dimensionLevel==2"></el-tab-pane>
                <el-tab-pane label="结果设置" name="second"></el-tab-pane>
              </el-tabs>
              <div class="" v-if="activeName=='first' && dimensionLevel==2 ">
                <div class="button_box">
                  <el-button type="primary" @click="handleQuestion('add')">新增</el-button>
                  <div class="info_tabs_name">
                    <el-input v-model="searchKey" placeholder="请输入内容"></el-input>
                    <el-button type="primary" @click="getQuestionList">搜索</el-button>
                  </div>
                </div>
                <div class="roleRight_Container public-table-data" style="margin-top:20px">
                  <el-table
                      :data="tableData"
                      size="medium"
                      border
                      style="width: 100%;text-align: center"
                      align="center"
                      row-key="customerServiceId"
                      v-loading="loading"
                  >
                    <el-table-column fixed label="序号" type="index" width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="维度">
                      <template slot-scope="scope">
                        <div>{{ scope.row.examDimensionVo ? scope.row.examDimensionVo.name : '' }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="seq" label="题目" min-width="120">
                      <template slot-scope="scope">
                        <div>A:{{ scope.row.name }}</div>
                        <div>B:{{ scope.row.name2 }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="seq" label="排序" width="100"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                      <template slot-scope="scope">
                        <el-button
                            plain
                            type="primary"
                            @click="handleQuestion('edit',scope.row)"
                            size="small"
                        >编辑
                        </el-button
                        >
                        <el-button
                            plain
                            type="danger"
                            @click="handleDelect(scope.row)"
                            size="small"
                        >删除
                        </el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                  <div class="public-pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.pageNo"
                        :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
              <div class="wd_content" v-if="activeName=='second' && dimensionLevel">
                <div class="content_info_wd">
                  <template v-if="dimensionLevel==2">
                    <div class="title_top">维度结果</div>
                    <div class="content_item_wd" v-for="(item,index) in examDimensionResults" :key="index">
                      <div class="left_box">{{ item.name }}</div>
                      <el-input style="width: 80%;margin: 0 5px" type="textarea" :rows="4" v-model="item.content"
                                placeholder="请输入内容"></el-input>
                      <div>{{ item.title }}</div>
                    </div>
                    <div style="text-align: center">
                      <el-button @click="saveDimensionInfo" type="primary">保存</el-button>
                    </div>
                    <div class="title_top">性格特点（职业性格综合描述中使用）</div>
                    <div class="content_info_wd">
                      <div class="content_item_wd" v-for="(item,index) in characteristicsResults" :key="index">
                        <div class="left_box">{{ item.name }}</div>
                        <el-input style="width: 80%;margin: 0 5px" type="textarea" :rows="4" v-model="item.content"
                                  placeholder="请输入内容"></el-input>
                        <div>{{ item.title }}</div>
                      </div>
                      <div style="text-align: center">
                        <el-button @click="saveCharacteristic" type="primary">保存</el-button>
                      </div>
                    </div>
                  </template>
                  <template v-if="dimensionLevel==1">
                    <div class="content_item_wd">
                      <div>子维度引导语</div>
                      <el-input style="width: 81%;margin: 0 5px" type="textarea" :rows="4" v-model="intro"
                                placeholder="请输入内容"></el-input>
                    </div>
                    <div style="text-align: center">
                      <el-button @click="saveDimensionSub" type="primary">保存</el-button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active_item==2">
        <div class="tag_tome_bole">
          <div class="left">
            <div @click='editSave(2,"add")' class="name_box_head">能力倾向 <i class="el-icon-circle-plus-outline"
                                                                          style="margin-right: 10px"></i></div>
            <div class="content_left">
              <el-tree :highlight-current="true" style="text-align: center"
                       :default-expand-all="true"
                       :expand-on-click-node="false" :data="abilityTendency" :props="defaultProps"
                       @node-click="handleAbilityClick">
                 <span class="custom-tree-node" style="width:100%;display: flex;justify-content: space-between"
                       slot-scope="{ node, data }">
        <span style="display: block;max-width:80px;overflow: hidden;text-overflow: ellipsis ">{{ node.label }}</span>
        <span>
          <i v-if="node.level==1" class="el-icon-circle-plus-outline" @click='editSave(2,"add",data)'
             style="margin-right: 10px"></i>
          <i class="el-icon-edit" @click='editSave(2,"edit",data)' style="margin-right: 10px"></i>
          <i @click="DelectDomin(2,data)" class="el-icon-delete" style="margin-right: 10px"></i>
        </span>
      </span>
              </el-tree>
            </div>
          </div>
          <div class="right">
            <div class="right_tops" style="margin-bottom: 10px">
              <div class="items" v-if="abilityName">能力倾向：{{ abilityName }}</div>
            </div>
            <div v-if="abilityLevel==2">
              <div class="wd_content">
                <div class="content_info_wd">
                  <div class="content_item_wd" v-if="index!=1" v-for="(item,index) in examDatumTheSumResults" :key="index">
                    <div class="left_box">{{ item.name }}</div>
                    <el-input style="width: 80%;margin: 0 5px" type="textarea" :rows="4" v-model="item.content"
                              placeholder="请输入内容"></el-input>
                    <div>{{ item.title }}</div>
                  </div>
                  <div class="title_top">相关建议</div>
                  <div class="content_item_wd">
                    <div class="left_box">提升建议</div>
                    <el-input style="width: 80%;margin: 0 5px" type="textarea" :rows="4" v-model="suggest"
                              placeholder="请输入内容"></el-input>
                  </div>
                  <div style="text-align: center">
                    <el-button @click="saveDatumInfo" type="primary">保存</el-button>
                  </div>
                </div>
                <div class="title_top">行为表现设置</div>
                <el-button @click="showPerformance" icon="el-icon-plus" style="margin-bottom: 15px">选择维度</el-button>
                <el-tabs closable @edit="handleTabsEdit" v-model="examDatumActiveCode" type="card"
                         @tab-click="Behavioral">
                  <el-tab-pane v-for="(item,index) in examDatumList" :label="item.name" :key="index"
                               :name="item.examDimensionId.toString()">
                    <div class="content_info_wd">
                      <div class="content_item_wd" v-for="(items,index) in item.results" :key="index">
                        <div class="left_box">{{ items.name }}</div>
                        <el-input style="width: 80%;margin: 0 5px" type="textarea" :rows="4" v-model="items.content"
                                  placeholder="请输入内容"></el-input>
                        <div>{{ items.title }}</div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
                <div style="text-align: center" @click="saveDatumCaseInfo">
                  <el-button type="primary">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active_item==3">
        <div class="tag_tome_bole">
          <div class="faceItem" v-for="(item,index) in facebookList" :key="index">
            <div class="name_box">{{item.faceName}}</div>
            <el-input style="width: 240px;margin: 0 5px" type="textarea" :rows="4" v-model="item.faceDescr"
                      placeholder="请输入内容"></el-input>
          </div>

        </div>
        <div class="box_info">
          <el-button size="medium" type="primary" @click="saveFaceContent"
          >保 存</el-button
          >
        </div>

      </div>
    </div>
    <el-dialog
        :title="'添加/编辑维度'"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            <el-input placeholder="请填写名称" v-model="params.name"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="英文" v-if="enShow && active_item==1">
            <el-input placeholder="请填写英文名称" v-model="params.enName"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="标识">
            <el-input :disabled="dimensionType=='edit'" placeholder="请填写标识" v-model="params.code"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="descr">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="seq" label="序号">
            <el-input placeholder="请填写序号" v-model="params.seq"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :title="'添加/编辑题目'"
        :visible.sync="subjectVisible"
        width="760px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div style="font-size:18px;font-weight: bold;margin-bottom: 30px">题目偏向</div>
        <el-form
            ref="ruleForm"
            :model="dataParams"
            label-width="80px"
        >
          <el-form-item label="A" prop="name">
            <el-input placeholder="请输入偏向A" v-model="dataParams.name"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="B">
            <el-input placeholder="请输入偏向B" v-model="dataParams.name2"></el-input>
          </el-form-item>
          <div style="display: flex;align-items: center">
            <el-form-item prop="code" label="维度">
              <el-select
                  :disabled="this.questionType=='edit'"
                  v-model="dictDataSelect"
                  placeholder="请选择"
                  ref="selectReport"
                  style="width: 245px"
                  clearable
              >
                <el-option
                    :value="params.menuId"
                    :label="params.menuId"
                    style="height: auto"
                >
                  <el-tree
                      :data="data"
                      node-key="menuId"
                      ref="TreeList"
                      :props="defaultProps"
                      :render-after-expand="true"
                      :expand-on-click-node="false"
                      @node-click="handleSelectNodeClick"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="倾向" prop="descr">-->
            <!--              <el-select-->
            <!--                  :disabled="this.questionType=='edit'"-->
            <!--                  v-model="datumSelect"-->
            <!--                  placeholder="请选择"-->
            <!--                  ref="datumSelect"-->
            <!--                  style="width: 245px"-->
            <!--                  clearable-->
            <!--              >-->
            <!--                <el-option-->
            <!--                    :value="params.menuId"-->
            <!--                    :label="params.menuId"-->
            <!--                    style="height: auto"-->
            <!--                >-->
            <!--                  <el-tree-->
            <!--                      :data="abilityTendency"-->
            <!--                      node-key="menuId"-->
            <!--                      ref="TreeList"-->
            <!--                      :props="defaultProps"-->
            <!--                      :render-after-expand="true"-->
            <!--                      :expand-on-click-node="false"-->
            <!--                      @node-click="handleDatumSelectNodeClick"-->
            <!--                  ></el-tree>-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
          </div>
          <el-form-item prop="seq" label="序号">
            <el-input placeholder="请填写序号" style="width: 100px" v-model="dataParams.seq"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="subjectVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleQuestionEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        :title="'添加/编辑行为表现分类'"
        :visible.sync="performanceVisible"
        width="480px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-if="performanceVisible">
        <el-tree :default-expand-all="true"
                 :check-on-click-node="true"
                 :check-strictly="true"
                 node-key="examDimensionId"
                 :default-checked-keys="examDimension"
                 :expand-on-click-node="false" style="text-align: center" :data="behavior" :props="defaultProps"
                 show-checkbox @check-change="handleCheckChange"></el-tree>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="performanceVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="saveDimensionPerformance"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";

export default {
  components: {},
  data() {
    return {
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      PAGE_SIZE,
      total: 0,
      loading: false,
      detalisObj: {},
      active_item: 3,
      activeName: 'first',
      input: '',
      tableData: [],
      defaultProps: {
        children: 'childrens',
        label: 'name'
      },
      dialogVisible: false,
      params: {
        parentId: 0
      },
      abilityTendency: [],
      abilityLevel: '',
      abilityName: '',
      abilityCode: '',
      abilityParentId: '',
      data: [],
      dimensionLevel: '',
      dimensionName: '',
      dimensionCode: '',
      dimensionType: '',
      dimensionCase: '',
      examDimensionId: '',
      dimensionParentId: '',
      //维度结果
      examDimensionResults: [
        {
          content: "",
          maxScore: 2,
          minScore: 0,
          name: "[0,2]",
          title: "很低"
        },
        {
          content: "",
          maxScore: 4,
          minScore: 2,
          name: "[2,4]分",
          title: "较低"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "中"
        },
        {
          content: "",
          maxScore: 8,
          minScore: 6,
          name: "[6,8]分",
          title: "较高"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 8,
          name: "[8,10]分",
          title: "很高"
        }
      ],
      oldexamDimensionResults: [
        {
          content: "",
          maxScore: 2,
          minScore: 0,
          name: "[0,2]",
          title: "很低"
        },
        {
          content: "",
          maxScore: 4,
          minScore: 2,
          name: "[2,4]分",
          title: "较低"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "中"
        },
        {
          content: "",
          maxScore: 8,
          minScore: 6,
          name: "[6,8]分",
          title: "较高"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 8,
          name: "[8,10]分",
          title: "很高"
        }
      ],
      //性设置结果
      characteristicsResults: [
        {
          content: "",
          maxScore: 2,
          minScore: 0,
          name: "[0,2]",
          title: "很低"
        },
        {
          content: "",
          maxScore: 4,
          minScore: 2,
          name: "[2,4]分",
          title: "较低"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "中"
        },
        {
          content: "",
          maxScore: 8,
          minScore: 6,
          name: "[6,8]分",
          title: "较高"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 8,
          name: "[8,10]分",
          title: "很高"
        }
      ],
      oldCharacteristicsResults: [
        {
          content: "",
          maxScore: 2,
          minScore: 0,
          name: "[0,2]",
          title: "很低"
        },
        {
          content: "",
          maxScore: 4,
          minScore: 2,
          name: "[2,4]分",
          title: "较低"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "中"
        },
        {
          content: "",
          maxScore: 8,
          minScore: 6,
          name: "[6,8]分",
          title: "较高"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 8,
          name: "[8,10]分",
          title: "很高"
        }
      ],
      intro: '',
      subjectVisible: false,
      dataParams: {
        view: 've3',
        answerWay: 'sel1',
        seq: 1
      },
      dictDataSelect: '',
      datumSelect: '',
      searchKey: '',
      questionType: '',
      //能力倾向相关
      examDatumId: '',
      examDatumList: [],
      examDatumActiveCode: '',
      examDatumTheSumResults: [
        {
          content: "",
          maxScore: 4,
          minScore: 0,
          name: "[0,4]分",
          title: "弱势（待发展）"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "一般"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 6,
          name: "[6,10]分",
          title: "优势"
        },
      ],
      oldExamDatumTheSumResults: [
        {
          content: "",
          maxScore: 4,
          minScore: 0,
          name: "[0,4]分",
          title: "弱势（待发展）"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "一般"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 6,
          name: "[6,10]分",
          title: "优势"
        },
      ],
      examDatumBehaviorPerformance: [
        {
          content: "",
          maxScore: 4,
          minScore: 0,
          name: "[0,4]分",
          title: "待发展"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "一般"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 6,
          name: "[6,10]分",
          title: "优势"
        },
      ],
      oldExamDatumBehaviorPerformance: [
        {
          content: "",
          maxScore: 4,
          minScore: 0,
          name: "[0,4]分",
          title: "待发展"
        },
        {
          content: "",
          maxScore: 6,
          minScore: 4,
          name: "[4,6]分",
          title: "一般"
        },
        {
          content: "",
          maxScore: 10,
          minScore: 6,
          name: "[6,10]分",
          title: "优势"
        },
      ],
      defaultKey: [],

      //行为表现设置
      performanceVisible: false,
      examDimension: [],

      editDataCode: '',
      enShow: true,

      behavior: [],
      suggest:'',
      facebookList:[]
    };
  },
  watch: {},
  created() {
    this.getAppraisalData();
    this.getTreeList()
    this.getAbilityTendency()
    this.getFacebookList()
  },
  methods: {
    //保存脸谱内容
    saveFaceContent(){
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {

        const {data: resData} = await this.$post(
            "/exam/face/list",
            this.facebookList,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getFacebookList()
      });
    },
    //获取脸谱列表
    async getFacebookList(){
      this.loading = true;
      const {data: resData} = await this.$get("/exam/face/list");
      this.loading = false;
      if (resData.result != 200) return;
      this.facebookList = resData.data
    },
    //能力倾向选择
    handleAbilityClick(data) {
      this.abilityLevel = data.nodeLevel
      this.abilityName = data.name
      this.abilityCode = data.code
      this.abilityParentId = data.examDatumId
      this.examDatumId = data.examDatumId
      if (data.nodeLevel == 2) {
        this.getExamDatumList()
        this.getExamDatumContent()
      }
    },
    //获取倾向的结果内容
    async getExamDatumContent() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/datum/result/list/0/" + this.examDatumId);
      this.loading = false;
      if (resData.result != 200) return;
      this.suggest = ''
      if (resData.data) {
        this.examDatumTheSumResults = resData.data
        this.suggest = resData.data[0].suggest
      } else {
        this.examDatumTheSumResults = JSON.parse(JSON.stringify(this.oldExamDatumTheSumResults))
        this.suggest = ''
      }
    },
    //保存倾向的结果内容
    saveDatumInfo() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        this.examDatumTheSumResults[0].suggest = this.suggest
        let obj = {
          examDatumId: this.examDatumId,
          examDatumResults: this.examDatumTheSumResults,
          // suggest:this.suggest
        }
        const {data: resData} = await this.$post(
            "/exam/datum/result/info",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getExamDatumList()
        this.getExamDatumContent()
      });
    },
    //选择行为表现对应的维度
    showPerformance() {
      this.getExamDatumList(1)
    },
    //行为表现分类删除
    handleTabsEdit(e) {
      this.$confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/datum/dimension/ids/${e}/${this.examDatumId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        if (this.examDimension.length) {
          this.examDimension.map((item, index) => {
            if (item == e) {
              this.examDimension.splice(index, 1)
            }
          })
        } else {
          this.examDimension = []
        }
        this.getExamDatumList()
        this.getExamDatumContent()
        this.$message.success("删除成功!");
      });
    },
    //行为表现设置
    handleCheckChange(data, checked) {
      if (checked) {
        this.examDimension.push(data.examDimensionId)
      } else {
        if (this.examDimension.length) {
          this.examDimension.map((item, index) => {
            if (item == data.examDimensionId) {
              this.examDimension.splice(index, 1)
            }
          })
        }
      }
    },
    //保存行为表现分类的内容
    async saveDimensionPerformance() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        let obj = {
          examDatumId: this.examDatumId,
          examDimensionIds: this.examDimension,
        }
        const {data: resData} = await this.$post(
            "/exam/datum/dimension/ids",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.performanceVisible = false
        this.getExamDatumList()
        this.getExamDatumContent()
      });
    },
    //行为表现
    Behavioral(tab, event) {
      // this.getExamDatumCaseContent()
    },
    //获取行为表现的分类列表
    async getExamDatumList(e) {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/datum/dimension/list/" + this.examDatumId);
      this.loading = false;
      if (resData.result != 200) {
        this.examDatumList = []
        this.examDatumActiveCode = ''
        this.examDimension = []
        return;
      }
      if (resData.data) {
        this.examDimension = []
        this.examDatumList = resData.data
        this.examDatumActiveCode = resData.data[0].examDimensionId.toString()
        resData.data.map((item, index) => {
          this.examDimension.push(item.examDimensionId)
        })

      } else {
        this.examDatumList = []
        this.examDatumActiveCode = ''
        this.examDimension = []
      }
      this.behavior = []
      if (e == 1) {
        this.behavior = JSON.parse(JSON.stringify(this.data))
        if (resData.data) {
          this.behavior.map(item => {
            if (item.childrens) {
              item.childrens.map(items => {
                resData.data.map(itemchild => {
                  if (items.examDimensionId == itemchild.examDimensionId) {
                    items.disabled = true
                  }
                })
              })
            }
          })
        }
        this.performanceVisible = true
      }
    },
    //获取行为表现的内容
    async getExamDatumCaseContent() {
      if (this.examDatumActiveCode) {
        this.loading = true;
        const {data: resData} = await this.$get("/exam/datum/result/list/" + this.examDatumActiveCode + "/" + this.examDatumId);
        this.loading = false;
        if (resData.result != 200) return;
        if (resData.data) {
          this.examDatumBehaviorPerformance = resData.data
        } else {
          this.examDatumBehaviorPerformance = JSON.parse(JSON.stringify(this.oldExamDatumBehaviorPerformance))
        }
      }
    },
    //保存行为表现的设置内容
    saveDatumCaseInfo() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        let arr = []
        this.examDatumList.map(item => {
          let object = {
            examDatumResults: item.results,
            examDimensionId: item.examDimensionId
          }
          arr.push(object)
        })
        let obj = {
          examDatumId: this.examDatumId,
          results: arr
          // examDatumResults: this.examDatumBehaviorPerformance,
          // examDimensionId: this.examDatumActiveCode
        }
        const {data: resData} = await this.$post(
            "/exam/datum/result/info2",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getExamDatumList()
      });
    },
    //维度设置
    //选择维度
    handleSelectNodeClick(node) {
      if (node.nodeLevel == 2) {
        this.dictDataSelect = node.name;
        this.dataParams.examDimensionCode = node.code;
        this.$refs.selectReport.blur();
      }
    },
    //选择倾向
    handleDatumSelectNodeClick(node) {
      if (node.nodeLevel == 2) {
        this.datumSelect = node.name;
        this.dataParams.examDatumCode = node.code;
        this.$refs.datumSelect.blur();
      }
    },
    //获取题目
    async getQuestionList() {
      this.loading = true;
      let obj = {
        examId: this.$route.query.examId,
        examDimensionCode: this.dimensionCode,
        searchKey: this.searchKey
      }
      const {data: resData} = await this.$get("/exam/question/list", {
        params: {
          ...obj,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.tableData = resData.data
      } else {
        this.tableData = []
      }
      if (resData.page) {
        this.total = resData.page.count;
      } else {
        this.total = 1;
      }
    },
    //题目新增编辑弹框
    async handleQuestion(e, item) {
      this.questionType = e
      if (e == 'edit') {
        this.loading = true;
        const {data: resData} = await this.$get("/exam/question/info/" + item.questionId);
        this.loading = false;
        if (resData.result != 200) return;
        this.dataParams = resData.data
        this.dataParams.examDimensionCode = resData.data.examDimensionVo.code
        this.dictDataSelect = resData.data.examDimensionVo.name
        this.subjectVisible = true
      } else {
        this.dataParams = {
          view: 've3',
          answerWay: 'sel1',
          seq: 1,
          examDimensionCode: this.dimensionCode
        }
        this.dictDataSelect = this.dimensionName;
        this.subjectVisible = true
      }
    },
    //删除
    handleDelect(row) {
      this.$confirm("此操作将删除题目数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/question/info/${row.questionId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getQuestionList();
        this.$message.success("删除成功!");
      });
    },
    //题目新增编辑
    handleQuestionEdit() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (this.questionType == 'add') {
          this.dataParams.examId = this.$route.query.examId;
          const {data: resData} = await this.$post(
              "/exam/question/info",
              this.dataParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("操作成功!");
          this.getQuestionList()
          this.subjectVisible = false
        } else {
          this.dataParams.examId = this.$route.query.examId;
          let obj = {
            view: 've3',
            answerWay: 'sel1',
            name: this.dataParams.name,
            name2: this.dataParams.name2,
            examDatumCode: this.dataParams.examDatumCode,
            examDimensionCode: this.dataParams.examDimensionCode,
            seq: this.dataParams.seq,
            examId: this.$route.query.examId,
            questionId: this.dataParams.questionId
          }
          const {data: resData} = await this.$put(
              "/exam/question/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.subjectVisible = false
          this.$message.success("操作成功!");
          this.getQuestionList()
        }
      });
    },
    //获取维度引导语的内容
    async getExamDimension() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/dimension/intro/" + this.examDimensionId);
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data.intro) {
        this.intro = resData.data.intro
      }
    },
    //获取维度的结果内容
    async getDimensionResults() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/dimension/intro/info/" + this.examDimensionId);
      this.loading = false;
      if (resData.result != 200) return;
      this.examDimensionResults = []
      if (resData.data.examDimensionResults) {
        this.examDimensionResults = resData.data.examDimensionResults
      } else {
        this.examDimensionResults = JSON.parse(JSON.stringify(this.oldexamDimensionResults))
      }
    },
    //获取性格设置的结果内容
    async getCharacteristicsResults() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/dimension/intro/info/" + this.examDimensionId + '?resultType=' + this.detalisObj.scheme);
      this.loading = false;
      if (resData.result != 200) return;

      this.characteristicsResults = []
      if (resData.data.examDimensionResults) {
        this.characteristicsResults = resData.data.examDimensionResults
      } else {
        this.characteristicsResults = JSON.parse(JSON.stringify(this.oldCharacteristicsResults))
      }
    },
    //引导语设置修改 saveDimensionSub()
    saveDimensionSub() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        let obj = {
          examDimensionId: this.examDimensionId,
          intro: this.intro
        }
        const {data: resData} = await this.$post(
            "/exam/dimension/intro",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getExamDimension();
      });
    },
    //子维度内容设置修改
    saveDimensionInfo() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        let obj = {
          examDimensionId: this.examDimensionId,
          examDimensionResults: this.examDimensionResults,
        }
        const {data: resData} = await this.$post(
            "/exam/dimension/intro/info",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getExamDimension();
        this.getQuestionList()
        this.getDimensionResults()
        this.getCharacteristicsResults()
      });
    },
    //性格内容设置修改
    saveCharacteristic() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        this.characteristicsResults.map(item => {
          item.resultType = this.detalisObj.scheme
        })
        let obj = {
          examDimensionId: this.examDimensionId,
          examDimensionResults: this.characteristicsResults,
          // resultType:this.detalisObj.scheme
        }
        const {data: resData} = await this.$post(
            "/exam/dimension/intro/info",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("操作成功!");
        this.getExamDimension();
        this.getQuestionList()
        this.getDimensionResults()
        this.getCharacteristicsResults()
      });
    },

    handleCloseWd(code) {
      this.$confirm("此操作将永久删除维度, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/dimension/info/${this.$route.query.examId}/yrx`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getWDList();
        this.$message.success("删除成功!");
      });
      this.clearStore()
    },

    DelectDomin(e, item) {
      if (item.nodeLevel == 1) {
        if (item.childrens == undefined) {
          this.delectInfo(e, item)
        } else {
          this.$message.warning('该目录下还有内容，不能删除')
        }
      } else {
        this.delectInfo(e, item)
      }
    },

    delectInfo(e, item) {
      this.$confirm("此操作将删除题目数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        if (e == 1) {
          const {data: resData} = await this.$delete(
              `/exam/dimension/info/${this.$route.query.examId}/${item.code}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getTreeList()
          this.dimensionLevel = ''
          this.dimensionName = ''
          this.$message.success("删除成功!");
        } else {
          const {data: resData} = await this.$delete(
              `/exam/datum/info/${this.$route.query.examId}/${item.code}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getAbilityTendency()
          this.abilityLevel = ''
          this.abilityName = ''
          this.$message.success("删除成功!");
        }
      });
    },
    //维度和能力倾向编辑新增
    async editSave(e, type, item) {
      this.dimensionType = type
      this.dimensionCase = e
      if (type == 'add') {
        if (item) {
          this.enShow = false
        } else {
          this.enShow = true
        }
      } else {
        if (item.nodeLevel == 2) {
          this.enShow = false
        } else {
          this.enShow = true
        }
      }

      if (e == 1) {
        if (type == 'edit') {
          this.loading = true;
          const {data: resData} = await this.$get(
              `/exam/dimension/info/${this.$route.query.examId}/${item.code}`
          );
          this.loading = false;
          if (resData.result != 200) return;
          this.params = resData.data
          this.dialogVisible = true;
        } else {
          this.params = {}
          if (item) {
            this.params.parentId = item.examDimensionId
          }
          this.dialogVisible = true;
        }
      } else {
        if (type == 'edit') {
          this.loading = true;
          const {data: resData} = await this.$get(
              `/exam/datum/info/${this.$route.query.examId}/${item.code}`
          );
          this.loading = false;
          if (resData.result != 200) return;
          this.params = resData.data
          this.dialogVisible = true;
        } else {
          this.params = {}
          if (item) {
            this.params.parentId = item.examDatumId
          }
          this.dialogVisible = true;
        }
      }
    },
    //能力倾向树列表
    async getAbilityTendency() {
      this.loading = true;
      let obj = {
        examId: this.$route.query.examId,
        tree: true,
      }
      const {data: resData} = await this.$get("/exam/datum/list", {
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.abilityTendency = resData.data

    },
    //获取维度树的列表
    async getTreeList() {
      this.loading = true;
      let obj = {
        examId: this.$route.query.examId,
        tree: true,
      }
      const {data: resData} = await this.$get("/exam/dimension/list", {
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.data = resData.data
      this.behavior = resData.data
    },
    //维度和能力倾向编辑新增
    async handleDimension(e, type) {
      this.dimensionType = type
      this.dimensionCase = e
      if (e == 1) {
        if (type == 'edit') {
          this.loading = true;
          const {data: resData} = await this.$get(
              `/exam/dimension/info/${this.$route.query.examId}/${this.dimensionCode}`
          );
          this.loading = false;
          if (resData.result != 200) return;
          this.params = resData.data
          this.dialogVisible = true;
        } else {
          this.params = {}
          this.dialogVisible = true;
        }
      } else {
        if (type == 'edit') {
          this.loading = true;
          const {data: resData} = await this.$get(
              `/exam/datum/info/${this.$route.query.examId}/${this.abilityCode}`
          );
          this.loading = false;
          if (resData.result != 200) return;
          this.params = resData.data
          this.dialogVisible = true;
        } else {
          this.params = {}
          this.dialogVisible = true;
        }
      }
    },
    //维度和能力倾向编辑新增操作
    handleEdit() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        this.params.examId = this.$route.query.examId;
        if (this.dimensionCase == 1) {
          const {data: resData} = await this.$post(
              "exam/dimension/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.dialogVisible = false;
          this.$message.success("操作成功!");
          this.getTreeList();
          this.params = {};
        } else {
          const {data: resData} = await this.$post(
              "exam/datum/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.dialogVisible = false;
          this.$message.success("操作成功!");
          this.getAbilityTendency();
          this.params = {};
        }
      });

    },
    //维度选择
    handleNodeClick(data) {
      this.dimensionLevel = data.nodeLevel
      this.dimensionName = data.name
      this.dimensionCode = data.code
      this.dimensionParentId = data.examDimensionId
      this.examDimensionId = data.examDimensionId
      this.getExamDimension()
      if (data.nodeLevel == 1) {
        this.activeName = 'second'
      }
      if (data.nodeLevel == 2) {
        this.getQuestionList()
        this.getDimensionResults()
        this.getCharacteristicsResults()
      }
    },

    handleClick(tab, event) {
      // console.log(tab, event);
    },

    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;
      this.queryTableData();
    },
    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.queryTableData();
    },

    changActiveItem(e) {
      this.active_item = e
      if (this.active_item == 1) {
        this.dimensionLevel = ''
        this.dimensionName = ''
      } else {
        this.abilityLevel = ''
        this.abilityName = ''
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  }
};
</script>

<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.box_intab {
  padding: 30px 20px;
  cursor: pointer;
  width: auto;

  .chang_tab {
    display: flex;
    align-items: center;
    cursor: pointer;

    .item_box {
      width: 100px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      color: #409EFF;
      border: 1px solid #b3d8ff;
      background: #ecf5ff;
      margin-right: 20px;
      border-radius: 4px;
    }

    .item_box:hover {
      background: #409EFF;
      border-color: #409EFF;
      color: #FFF;
    }

    .active_item {
      background: #409EFF;
      border-color: #409EFF;
      color: #FFF;
    }
  }

  .tag_tome_bole {
    margin-top: 15px;
    display: flex;
    font-size: 14px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);

    .left {
      width: 200px;
      border-right: 1px solid rgba(0, 0, 0, 0.2);

      .name_box_head {
        height: 35px;
        padding-left: 25px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        margin-bottom: 10px;
        line-height: 35px;
      }
    }

    .right {
      margin-left: 20px;
      width: calc(100% - 240px);

      .right_tops {
        display: flex;
        height: 35px;

        .items {
          margin-right: 20px;
          line-height: 35px;
        }
      }

      .button_box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .info_tabs_name {
          display: flex;
          align-items: center;
        }
      }

      .wd_content {
        .title_top {
          padding-bottom: 5px;
          font-size: 12px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
          margin-bottom: 20px;
        }

        .content_item_wd {
          display: flex;
          margin-bottom: 20px;

          .left_box {
            width: 90px;
            text-align: right;
          }
        }
      }
    }
  }
}

.tag_tome_bole{
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  .faceItem{
    display: flex;
    margin-bottom: 10px;
    .name_box{
      width: 60px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.box_info{
  text-align: center;
}


</style>
<style>
.box_intab .cell {
  text-align: center;
}

.public-dialog-form .el-checkbox .el-checkbox__inner {
  display: none;
}

.public-dialog-form div[role="group"] .el-checkbox .el-checkbox__inner {
  display: inline-block;
}

</style>